import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, MessageCircle } from "lucide-react";
import { nav, logo, contact } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#07070d]/90 backdrop-blur-md border-b border-[#00ff87]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <img src={logo} alt="DaddyAnna Online Cricket ID" className="h-11 w-auto drop-shadow-[0_0_12px_rgba(0,255,135,0.4)]" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((item) => {
              const active = location.pathname === item.to;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${
                    active
                      ? "text-[#00ff87]"
                      : "text-gray-300 hover:text-[#00ff87]"
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </nav>

          <div className="hidden lg:block">
            <a
              href={contact.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="btn-neon inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-display font-semibold text-sm"
            >
              <MessageCircle size={17} /> Get Cricket ID
            </a>
          </div>

          <button
            className="lg:hidden text-[#00ff87] p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0b0b14]/98 backdrop-blur-md border-t border-[#00ff87]/15 px-4 py-4">
          <nav className="flex flex-col gap-1">
            {nav.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={`px-4 py-3 rounded-lg text-base font-medium ${
                  location.pathname === item.to
                    ? "text-[#00ff87] bg-[#00ff87]/10"
                    : "text-gray-300"
                }`}
              >
                {item.label}
              </Link>
            ))}
            <a
              href={contact.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="btn-neon mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-lg font-display font-semibold"
            >
              <MessageCircle size={18} /> Get Cricket ID
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
